import React, { type ComponentPropsWithoutRef, forwardRef } from 'react';

import { Flex } from '../../Flex';
import { AlertCircleOutlinedIcon, InfoCircleOutlinedIcon } from '../../Icon/icons';

import { Styled } from './styles';
import type { FeedbackProps } from './types';

export { intents } from './types';
export type { FeedbackIntent, FeedbackProps } from './types';

type SmallProps = Omit<ComponentPropsWithoutRef<'small'>, keyof FeedbackProps | 'color'>;
type Props = SmallProps & FeedbackProps;

export const FormFeedback = forwardRef<HTMLElement, Props>(({ children, intent, ...props }, ref) => (
  <Styled.Caption {...props} intent={intent} ref={ref}>
    <Flex.Row space="xs" alignItems="flex-start" flexWrap="nowrap">
      {intent === 'danger' && (
        <Styled.IconBox>
          <InfoCircleOutlinedIcon />
        </Styled.IconBox>
      )}
      {intent === 'warning' && (
        <Styled.IconBox>
          <AlertCircleOutlinedIcon />
        </Styled.IconBox>
      )}
      <span>{children}</span>
    </Flex.Row>
  </Styled.Caption>
));
